import { render, staticRenderFns } from "./TaskListInfo.vue?vue&type=template&id=35518878"
import script from "./TaskListInfo.vue?vue&type=script&lang=js"
export * from "./TaskListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports